import * as dealTypes from './mutations_types'
import * as leadTypes from '../../../../leads/components/show/store/mutations_types'
import * as followUpTypes from '../follow_ups/store/mutations_types'
import * as emailTypes from '../emails/store/mutations_types'
import * as attachmentTypes from '../attachments/store/mutations_types'
import * as taskTypes from '../tasks/store/mutations_types'
import * as quotationTypes from '../quotations/store/mutations_types'
import { get } from 'services/deals'

export const loadDeal = (context, id) => {
    return get(id)
        .then(response => {
            context.commit(dealTypes.SET, response.data.info)
            context.commit(leadTypes.SET_INFO, response.data.lead)
            context.commit(followUpTypes.SET, response.data.follow_ups)
            context.commit(attachmentTypes.SET, response.data.attachments)
            context.commit(emailTypes.SET, response.data.emails)
            context.commit(taskTypes.SET, response.data.tasks)
            context.commit(quotationTypes.SET, response.data.quotations)
        })
}

export const setDeal = (context, deal) => {
    context.commit(dealTypes.SET, deal.info)
    context.commit(leadTypes.SET_INFO, deal.lead)
    context.commit(followUpTypes.SET, deal.follow_ups)
    context.commit(attachmentTypes.SET, deal.attachments)
    context.commit(emailTypes.SET, deal.emails)
    context.commit(taskTypes.SET, deal.tasks)
    context.commit(quotationTypes.SET, deal.quotations)
}

export const clearDeal = (context) => {
    context.commit(dealTypes.CLEAR)
    context.commit(leadTypes.CLEAR)
    context.commit(followUpTypes.CLEAR)
    context.commit(attachmentTypes.CLEAR)
    context.commit(emailTypes.CLEAR)
    context.commit(taskTypes.CLEAR)
    context.commit(quotationTypes.CLEAR)
}

export const saveDeal = (context, deal) => context.commit(dealTypes.SET, deal)



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/store/actions.js